export const PRICING_CALCULATOR_PLATFORM_FEE = 650;
export const PRICING_CALCULATOR_ROUNDING_STEPS = [250, 500, 1000] as const;

export interface PricingCalculatorRange {
  minMarketValue: number;
  dealerMargin: number;
}

export interface PricingCalculatorConfig {
  ranges: PricingCalculatorRange[];
  platformCommissionPercent: number;
  includePlatformFeeInCosts: boolean;
  expectedPriceRounding?: number | null;
  requiredPrice: boolean;
  listPriceMarginPercentage?: number | null;
}

export interface PricingCalculatorConfigResponse {
  config: PricingCalculatorConfig | null;
  inherited: boolean;
  hasOwnConfig: boolean;
  updatedAt?: string | Date | null;
  updatedBy?: string | null;
}

export const EMPTY_PRICING_CONFIG_RESPONSE: PricingCalculatorConfigResponse = {
  config: null,
  inherited: false,
  hasOwnConfig: false,
};

export interface PricingCalculatorResultLine {
  label: string;
  value: string;
  highlight?: boolean;
  muted?: boolean;
  negative?: boolean;
  strong?: boolean;
  highlightRow?: boolean;
}

export interface PricingCalculatorResult {
  marketValue: number;
  dealerCosts: number;
  dealerMargin: number;
  platformFee: number;
  paymentValue: number;
  platformCommission: number;
  suggestedPrice: number;
  appliedRangeIndex: number;
  appliedRangeLabel: string;
  marketValuePercent: number;
  breakdownLines: PricingCalculatorResultLine[];
}

export interface PricingCalculatorCalculateRequest {
  marketValue: number;
  dealerCosts: number;
  evaluationId?: string;
  oemDealerId?: string;
  evalDealerId?: string;
  config?: PricingCalculatorConfig;
}

export interface PricingCalculatorAppliedPrice {
  suggestedPrice: number;
  marketValue: number;
  dealerCosts: number;
  paymentValue: number;
}

export interface PricingCalculatorPanelValues {
  marketValue: number;
  dealerCosts: number;
  valid: boolean;
}

// API DTOs (trade-in-pricing-config)

export interface TradeInPricingConfigApi {
  ranges?: PricingCalculatorRange[];
  oemDealerCommissionPercentage?: number;
  includePlatformFeeCust?: boolean;
  expectedPriceRounding?: number | null;
  requiredPrice?: boolean;
  listPriceMarginPercentage?: number | null;
  inherited?: boolean;
  hasOwnConfig?: boolean;
  updatedAt?: string | null;
  updatedBy?: string | null;
  updatedByName?: string | null;
}

export interface TradeInPricingConfigSaveApi {
  ranges: PricingCalculatorRange[];
  oemDealerCommissionPercentage: number;
  includePlatformFeeCust: boolean;
  expectedPriceRounding?: number | null;
  requiredPrice: boolean;
  listPriceMarginPercentage?: number | null;
}

export interface TradeInPricingBreakdownApi {
  marketValue?: number;
  dealerMargin?: number;
  dealerMarginPercentage?: number;
  dealerCosts?: number;
  platformFeeCost?: number;
  payPrice?: number;
  oemDealerCommission?: number;
  oemDealerCommissionPercentage?: number;
  expectedPrice?: number;
  expectedPricePercentage?: number;
  appliedRangeLabel?: string;
}
